import { useContext, useState } from "react";
import logo from "../../assets/img/logo.png";
import wrong from "../../assets/img/11132.jpg";
import "./QRCodeInformation.scss";
export default function QRCodeInformation() {
  const [isValid, setIsValid] = useState(true);
  return (
    <div className="qr-code-information">
      {isValid ? (
        <div className="mx-auto">
          <div class="alert alert-success text-center mt-5 w-75 mx-auto" role="alert">
            قرارداد مورد تایید است.
          </div>
          <br />
          <div className="mt-5 information-container">
            <div className="information-logo">
              <img src={logo} alt="" style={{ width: "100px" }} />
            </div>
            <div className="information-item first-child d-flex justify-content-between">
              <div className="title">نوع قرارداد</div>
              <div className="description">قرارداد 1</div>
            </div>
            <div className="information-item d-flex justify-content-between">
              <div className="title">کد ملی طرف اول</div>
              <div className="description">2110874531</div>
            </div>
            <div className="information-item d-flex justify-content-between">
              <div className="title">کد ملی طرف دوم</div>
              <div className="description">2122458756</div>
            </div>
            <div className="information-item d-flex justify-content-between">
              <div className="title">مبلغ قرارداد</div>
              <div className="description">120,000,000 تومان</div>
            </div>
            <div className="information-item d-flex last-child justify-content-between">
              <div className="title">زمان قرارداد</div>
              <div className="description">1400/02/01</div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div class="alert alert-danger mb-0 text-center  mx-auto  mt-5 w-75" role="alert">
            کد مورد نظر معتبر نیست.
          </div>
          <div className="wrong-image">
            <img src={wrong} alt="" />
          </div>
        </div>
      )}
    </div>
  );
}
